module.exports = __webpack_public_path__ + "img/Downloaded.1caf6a40.png";